import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_NOTE_DETAILS,
    CLEAR_NOTE_DETAILS_ERROR,
    LOAD_NOTE_DETAILS_REQUEST,
    LOAD_NOTE_DETAILS_SUCCESS,
    LOAD_NOTE_DETAILS_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_NOTE_DETAILS,
    CLEAR_ERROR: CLEAR_NOTE_DETAILS_ERROR,
    LOAD_REQUEST: LOAD_NOTE_DETAILS_REQUEST,
    LOAD_SUCCESS: LOAD_NOTE_DETAILS_SUCCESS,
    LOAD_FAILURE: LOAD_NOTE_DETAILS_FAILURE
}